import { logger } from '@fiverr-private/obs';
import { datetime } from '@fiverr-private/futile';

/**
 * Calculates the time in days between now and the deadline.
 * @param {string|Date} deadline the deadline date representation
 */
export const daysToDeadline = (deadline) => {
    try {
        return datetime.daysToTargetDate(deadline);
    } catch (error) {
        logger.warn(error,
            {
                message: 'Invalid deadline date supplied',
                flow: 'stored global messages'
            }
        );
        return 0;
    }
};
